/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from 'react';
import useOfficialDocuments from "./content";
import { Row, Col, Spinner } from 'reactstrap';
import { useWorkFlow, LOCK_BUTTON } from "../../../contexts/workflow";
import { _translate as t, WeverCoreContext } from "../../../../services/core";
import env from "../../../../services/environment";
var Index = function Index() {
  // Utilisation du context pour récupérer le diag et la communauté attachée.
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;

  // Utilisation des documents officiels
  var _useOfficialDocuments = useOfficialDocuments(),
    isValid = _useOfficialDocuments.isValid,
    props = _useOfficialDocuments.props,
    actions = _useOfficialDocuments.actions;
  useEffect(function () {
    if (!collector && !collector.diag) {
      return;
    }
    dispatcher({
      type: LOCK_BUTTON,
      value: true
    });
    actions.start([collector.diag.community.id]);
  }, []);
  useEffect(function () {
    dispatcher({
      type: LOCK_BUTTON,
      value: !isValid
    });
  }, [isValid]);
  if (!props.data && !isValid) {
    return /*#__PURE__*/React.createElement(Spinner, {
      color: "primary"
    });
  }
  return /*#__PURE__*/React.createElement(Col, {
    className: "offDocPaddingFix"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offDocTitle align-items-start flex-row d-flex fw-bold"
  }, t('collectorapp_official_documents_od_title')), /*#__PURE__*/React.createElement("div", {
    className: "offDocDesc align-items-start flex-row d-flex"
  }, /*#__PURE__*/React.createElement("p", null, t('collectorapp_official_documents_od_description'), "(", /*#__PURE__*/React.createElement("a", {
    className: "od-more-color",
    href: locale === 'fr' ? 'http://api.yeswever.com/media/6311f0aa68a40056154551.pdf' : 'http://api.yeswever.com/media/6311f0de27887860569142.pdf',
    target: "blank"
  }, t('collectorapp_cgu_know_more_od_2')), ").")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-2 d-flex justify-content-end align-items-center align-self-center"
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      padding: '10px',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: "offDocInput",
    type: "checkbox",
    checked: isValid,
    id: "cgu_accept",
    onChange: function onChange(e) {
      return actions.validate(e.target.checked);
    }
  }), ' ', /*#__PURE__*/React.createElement("br", null), ' ')), /*#__PURE__*/React.createElement(Col, {
    className: "col-10 d-flex justify-content-start align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-align-left"
  }, /*#__PURE__*/React.createElement("label", {
    for: "cgu_accept",
    style: {
      color: '#555',
      textAlign: 'left',
      paddingBottom: '7px'
    }
  }, t('collectorapp_accept_documents_right_od'))))), /*#__PURE__*/React.createElement("div", {
    className: "offDocConc align-items-start flex-row d-flex"
  }, t('collectorapp_official_documents_od_conclusion')), /*#__PURE__*/React.createElement("div", {
    className: "offDocConc align-items-start flex-row d-flex"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
    className: "od-more-color",
    href: "".concat(env.get('admin_url'), "/shared/community/").concat(collector.diag.community.id, "/information"),
    target: "blank"
  }, t('collectorapp_cgu_know_more_od')))));
};
export default Index;